import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { setShowBottomNav } from "@/redux/slices/bottomNavSlice";

export function useBottomNav() {
  const showBottomNav = useAppSelector(
    (state) => state.bottomNav.showBottomNav,
  );

  const dispatch = useAppDispatch();

  function toggleBottomNave(value: boolean) {
    dispatch(setShowBottomNav(value));
  }

  return { showBottomNav, toggleBottomNave };
}
